import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHotel } from "@/hooks/useHotel";
import { useHotelService } from "@/hooks/useHotelServices";
import { HotelServiceProviderType } from "@/types/hotelService";

export const ServiceSearchRedirectPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id = "" } = useParams();
  const { hotelId, isLoading: isHotelLoading, error: hotelError } = useHotel();
  const {
    data: service,
    isLoading: isServiceLoading,
    error: serviceError,
  } = useHotelService(id, hotelId ?? "");

  React.useEffect(() => {
    if (!service) {
      return;
    }

    const isPartnerService =
      service.providerType ===
      HotelServiceProviderType.GUESTERIA_PARTNERS_SERVICE;

    navigate(
      isPartnerService ? `/services/activity/${service.id}` : `/services/${id}`,
      {
        replace: true,
        state: isPartnerService ? { service } : undefined,
      },
    );
  }, [id, navigate, service]);

  if (isHotelLoading || isServiceLoading) {
    return (
      <div className="p-12">
        {t("services.page.loading", { defaultValue: "Loading..." })}
      </div>
    );
  }

  if (hotelError || serviceError || !hotelId) {
    return (
      <div className="p-12 text-red-600">
        {t("services.activity.errors.notFound", {
          defaultValue: "Service not found.",
        })}
      </div>
    );
  }

  return null;
};
